import googleMapInit from "./googleMap";

const mapDealers = (link) => {

    if ($(link).data('slug') === 'dealers') {
        let maps = $('.js-dealers-map'),
            page = maps.eq(0).data('page'), found = 0;

        maps.each((i, el) => {
            if($(el).hasClass('loaded')){
                found++;
            }
        })

        if (found < maps.length) {
            dealersAjax(renderMaps)
        }

        function dealersAjax(cb) {
            $.ajax({
                type: 'POST',
                url: ajax_url[0],
                dataType: "json",
                data: {
                    page: page,
                    action: 'get_dealers',
                },
                success: function (response) {
                    cb(response);

                },
                error: function (error) {
                    console.log('error', error);
                }
            });
        }

        function renderMaps(response) {
            maps.each((i, el) => {
                if (!$(el).hasClass('loaded')) {
                    let index = +$(el).data('number');

                    let options = {
                        loc: response[index],
                        zoom: 11,
                    };

                    googleMapInit(options, `.js-dealers-map[data-number="${index}"] #map`, true);
                }
            })
        }

    }
}

export default mapDealers;